/**
 * Where the API lives.
 *
 * Vite substitutes `import.meta.env` at build time, so this value is baked into the
 * bundle. That is why the production Docker image takes `VITE_API_URL` as a build
 * argument rather than a runtime environment variable.
 */

const DEFAULT_API_URL = 'http://localhost:8000';

/** Strip trailing slashes so joining a path never produces a double slash. */
export function normaliseBaseUrl(raw: string | undefined): string {
  const trimmed = raw?.trim();
  if (!trimmed) return DEFAULT_API_URL;
  return trimmed.replace(/\/+$/, '');
}

export const API_BASE_URL = normaliseBaseUrl(import.meta.env.VITE_API_URL);

/** Join a path onto the API origin, tolerating a leading slash or none. */
export function apiUrl(path: string, base: string = API_BASE_URL): string {
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${base}${suffix}`;
}
